import React from 'react';

/**
 * Catches render-time crashes anywhere below it and shows a readable message
 * instead of an unrecoverable black screen. Lets the user reset and continue.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Something went wrong.' };
  }

  componentDidCatch(error, info) {
    console.error('💥 [ErrorBoundary]', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, message: '' });
    if (typeof this.props.onReset === 'function') this.props.onReset();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        maxWidth: 520, margin: '40px auto', padding: '28px 24px',
        borderRadius: 18, background: 'rgba(14,14,26,0.97)',
        border: '1px solid rgba(239,68,68,0.3)', textAlign: 'center',
        color: '#E2E8F0', fontFamily: 'Inter, sans-serif',
      }}>
        <div style={{ fontSize: 34, marginBottom: 10 }}>⚠️</div>
        <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>
          This view hit an error
        </div>
        <div style={{ fontSize: 13, color: '#94A3B8', marginBottom: 20, lineHeight: 1.6 }}>
          {this.state.message}
        </div>
        <button
          onClick={this.handleReset}
          style={{
            padding: '10px 22px', borderRadius: 12, border: 'none', cursor: 'pointer',
            background: 'linear-gradient(135deg, #7C3AED, #06B6D4)', color: '#fff',
            fontWeight: 700, fontSize: 14,
          }}
        >
          Go back
        </button>
      </div>
    );
  }
}
